import React, { useEffect, useState } from 'react';
import { IBasicItem } from '../../../models/IBasicItem';
import styles from './Autocomplete.module.css';
import { UseFormRegister } from 'react-hook-form';

type AutocompleteProps = {
  name: string;
  defaultValue: string;
  required?: boolean;
  register: UseFormRegister<any>;
  validate: (data: string) => boolean;
  suggestions: IBasicItem[];
  onChange: (value: string) => void;
  onSelect: (selection: IBasicItem) => void;
};
const Autocomplete = (props: AutocompleteProps) => {
  const [active, setActive] = useState(0);
  const [input, setInput] = useState('');

  const onChange = e => {
    const input = e.currentTarget.value;
    setInput(input);
    props.onChange(input);
  };
  const onSelect = (suggestion: IBasicItem) => {
    setActive(0);
    setInput(suggestion.label);
    props.onSelect(suggestion);
  };
  const onKeyDown = e => {
    if (e.keyCode === 13) {
      // enter key
      setActive(0);
      setInput(props.suggestions[active].label);
    } else if (e.keyCode === 38) {
      // up arrow
      return active === 0 ? null : setActive(active - 1);
    } else if (e.keyCode === 40) {
      // down arrow
      return active - 1 === props.suggestions?.length ? null : setActive(active + 1);
    }
  };
  const renderAutocomplete = () => {
    if (input) {
      if (props.suggestions.length) {
        return (
          <ul className={styles.autocomplete}>
            {props.suggestions.map((suggestion, index) => {
              let className;
              if (index === active) {
                className = 'styles.active';
              }
              return (
                <li
                  className={className}
                  key={suggestion.value}
                  onClick={() => onSelect(suggestion)}
                >
                  {suggestion.label}
                </li>
              );
            })}
          </ul>
        );
      }
    }
    return <></>;
  };

  useEffect(() => {
    setInput(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <>
      <input
        type='text'
        className={styles.input}
        defaultValue={input}
        {...props.register(props.name, {
          required: props.required,
          validate: props.validate,
          onChange: onChange,
        })}
      />
      {renderAutocomplete()}
    </>
  );
};
export default Autocomplete;
